module.exports = __webpack_public_path__ + "img/Tutorial_Resultdetails.25104032.jpg";